/** @see DesignModuleNode.props.nodeTypeName. */
export enum NodeTypeName {
  access = 'Access',
  banner = 'Banner',
  begin = 'Begin',
  blankObject = 'Blank Object',
  completion = 'Completion',
  condition = 'Condition',
  custom = 'Custom',
  customScript = 'Custom Script',
  data = 'Data',
  dataAccess = 'Data Access',
  dataAccessCompletion = 'Data Access Completion',
  definition = 'Definition',
  dialogManager = 'Dialog Manager',
  dtmfMenu = 'Dtmf Menu',
  exit = 'Exit',
  flushPrompts = 'FLUSH PROMPTS',
  input = 'Input',
  intent = 'Intent',
  intentCategory = 'Intent (Category)',
  loopEscalation = 'Loop Escalation',
  module = 'Module',
  moduleBegin = 'Module Begin',
  moduleExit = 'Module Exit',
  moduleReference = 'Module Reference',
  note = 'Note',
  play = 'Play',
  playSavedPrompt = 'Play Saved Prompt',
  prompt = 'Prompt',
  promptReference = 'Prompt Reference',
  reference = 'Reference',
  reporting = 'Reporting',
  richText = 'Rich Text',
  router = 'Router',
  savePrompt = 'Save Prompt',
  saved = 'Saved',
  script = 'Script',
  sessionCompletion = 'Session Completion',
  simultaneousSessionCompletion = 'Simultaneous Session Completion',
  startSimultaneousSession = 'Start Simultaneous Session',
  tabular = 'Tabular',
  tabularRouter = 'Tabular Router',
  transition = 'Transition',
  variable = 'Variable',
  variableDefinition = 'Variable Definition',
  vxmlRender = 'VXML Render',
  withFiller = 'With Filler'
}
